
import { eventPost } from '@/utils/requestEvent';
import { eventPostNew } from '@/utils/requestEventNew';
import {
  getQueryString,
  getSessionToken,
  terminalFn,
  getBrowserName,
  urlParamsToJson,
  getSessionId,
  getOS, getOSVersion
} from '@/utils';
import { getDeviceModel } from '../service/land'
import appStore from '@/store/modules/app'
// import {
//   reportEvent
// } from '@/service/flyloans';
import { XFReport } from 'sword-js-sdk';

//埋点事件
export function eventData (data) {
  let eventDataIn = [data];
  eventDataIn[0].event_time = new Date().getTime();

  eventDataIn = JSON.stringify(eventDataIn);
  // 事件上报
  return eventReport(eventDataIn);
}

function getReportParams (data) {
  data.event_time = new Date().getTime();
  const from = localStorage.getItem('REPORT_FROM');
  if (from) {
    data.from = from;
  }
  let postData = {
    data: [data],
  };
  postData.data = JSON.stringify(postData.data);
  if (data.utm_source) {
    postData.utm_source = data.utm_source;
  } else {
    if (location.search.includes('utm_source=')) {
      if (location.search.split('utm_source=')[1].split('&')[0]) {
        postData.utm_source = location.search.split('utm_source=')[1].split('&')[0];
      }
    }

  }

  return postData;
}

// 现金贷埋点
export async function newEventData (data) {
  data.event_id = String(data.event_id)
  // let device_model = localStorage.getItem('device_model')
  //
  // if (data.event_id == 1002163 ||(data.event_id == 1005183 && data.from == 'isband')) {
  //   if (!device_model || true) { // 配合业务方每次都调用
  //     let res = await getDeviceModel();
  //     if (res.status == 1 && res.response) {
  //       localStorage.setItem('device_model', res.response.device_model)
  //       data.device_model = res.response.device_model
  //     }
  //   } else {
  //     data.device_model = device_model
  //   }
  //
  // }
  let utm_source = getQueryString('utm_source');
  data.utm_source = utm_source;
  try {
    data.url = location.href;
  } catch (error) {
    
  }
  // 新埋点同步上报
  try{
    const newEventId = window.newReportEventIds?.[data.event_id]
    newEventId && newEventSystemReport({
      eventId: newEventId,
      pageId: newEventId?.split('-')?.[1],
      ...data
    })
  } catch (error){

  }

  if(window.newReportEventIds && window.newReportEventIds.notReportOld === true){
    return;
  }

  return eventPost.post('/event/report', getReportParams(data));

}

// 新埋点系统
export async function newEventSystemReport (data) {
  let device_model = localStorage.getItem('device_model')
  let utm_source = getQueryString('utm_source');
  data.utm_source = utm_source;

  data = {
    // 如果有传手机号则获取传入的手机号 否则从session中获取
    mobile: sessionStorage.getItem('land_mobile_no') || atob(decodeURIComponent(getQueryString('land_mobile_no'))),
    ...data,
    ...urlParamsToJson(),
    anonymousId: getSessionToken(),
    time: new Date().getTime() + '',
    event_id: String(data.eventId),
    eventId: String(data.eventId),
    eventName: data.eventName,
    token: getSessionToken(),
    // pageInfo字段
    url: window.location.href,
    elementTargetUrl: data.elementTargetUrl,
    pageId: data.pageId,
    referer: document.referrer,
    // pageInfo: {
    //   url: window.location.href,
    //   elementTargetUrl: data.elementTargetUrl,
    //   pageId: data.pageId,
    //   referer: document.referrer,
    // },
    // envInfo: {
    //   appName: getQueryString('app_name') || 'xyf01',
    //   os: terminalFn(),
    //   browser: getBrowserName(),
    //   screenHeight:window.screen.height,
    //   screenWidth:window.screen.width,
    //   UA: navigator.userAgent,
    //   source_type:'wap'
    // },
    appName: getQueryString('app_name') || 'xyf01',
    os: terminalFn(),
    browser: getBrowserName(),
    screenHeight:window.screen.height,
    screenWidth:window.screen.width,
    UA: navigator.userAgent,
    source_type:'wap',
    type: urlParamsToJson()?.type || appStore?.state?.linkType
  }

  const newReportEventIds = window.newReportEventIds;
  if (newReportEventIds && newReportEventIds.reportNewV2) {
    reportNewV2({
      eventId: data.eventId,
      ...data
    });
    return;
  }

  return eventPostNew.post('', data);
}

let reporter;
export function reportNewV2(data) {
  try {
    if (!reporter) {
      // todo
      const config = {
        environment: env(),
        publicInfo: {
          device_id: getSessionId(),
          session_id: getSessionId(),
          cnl_pd_code: 'UGS003000077',
          utm_source: getQueryString('utm_source') || 'LandPage',
          app_name: getQueryString('app_name') || 'xyf01',
          app_version: '1.0.0',
          inner_app: localStorage.getItem('REPORT_APP') || 'xyf01',
          click_id: getQueryString('click_id'),
          request_id: getQueryString('request_id'),
          type: urlParamsToJson()?.type || appStore?.state?.linkType
        },
      };
      config.authInfo = {
        anonymousId: getSessionToken() || getSessionId()
      };
      reporter = XFReport.getInstance(config);
    }
    if (!data.eventId) {
      return;
    }

    // 新增打包时间上报
    if(data?.bizInfo){
      data.bizInfo.buildTime = window?.__BUILD_TIME__ 
    }else{
      data.bizInfo = {
        buildTime: window?.__BUILD_TIME__
      }
    }

    reporter.reportH5(
      data.eventId,
      data.elementName ||
        data.name ||
        (document.title || '').replace(/\u200E/g, '').trim() ||
        'LandPage',
      {
        mobile: data.mobile || sessionStorage.getItem('land_mobile_no'),
        ...(data.bizInfo || {}),
      },
      {
        device_id: getSessionId(),
        session_id: getSessionId(),
        cnl_pd_code: 'UGS003000077',
        utm_source: getQueryString('utm_source') || 'LandPage',
        app_name: getQueryString('app_name') || 'xyf01',
        app_version: '1.0.0',
        inner_app: localStorage.getItem('REPORT_APP') || 'xyf01',
        type: urlParamsToJson()?.type || appStore?.state?.linkType,
      },
      !!data.flushNow
    );
  } catch (e) {
    console.log(e);
  }
}



